'use client';

import BackgroundContainer from '@components/BackgroundContainer';
import Button from '@components/Button';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <html lang='de'>
      <body>
        <BackgroundContainer
          className='global-error-page'
          aria-label='Ein Fehler ist aufgetreten'
          as='section'
          variant='not-found'
        >
          <div className='not-found__actions'>
            <h1 className='not-found__title'>Fehler</h1>
            <h2>Ein kritischer Fehler ist aufgetreten.</h2>

            {/* Development mode: Show error details */}
            {process.env.NODE_ENV === 'development' && (
              <details
                style={{
                  marginTop: '2rem',
                  textAlign: 'left',
                  maxWidth: '600px',
                }}
              >
                <summary style={{ cursor: 'pointer', marginBottom: '1rem' }}>Technische Details</summary>
                <pre
                  style={{
                    background: 'rgba(0,0,0,0.1)',
                    padding: '1rem',
                    borderRadius: '4px',
                    fontSize: '0.875rem',
                    overflow: 'auto',
                  }}
                >
                  {error.message}
                  {'\n\n'}
                  {error.stack}
                </pre>
              </details>
            )}
            <div style={{ marginTop: '2rem' }}>
              <Button ghost white onClick={() => reset()}>
                Erneut versuchen
              </Button>
            </div>
          </div>
        </BackgroundContainer>
      </body>
    </html>
  );
}
